module.exports = __webpack_public_path__ + "static/DyeSub-51dd6f34b87e03510d029ac780cef89c.jpg";